import { render, staticRenderFns } from "./PLyricSearch.vue?vue&type=template&id=4c42bd25&scoped=true"
import script from "./PLyricSearch.vue?vue&type=script&lang=js"
export * from "./PLyricSearch.vue?vue&type=script&lang=js"
import style0 from "./PLyricSearch.vue?vue&type=style&index=0&id=4c42bd25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c42bd25",
  null
  
)

export default component.exports